// extracted by mini-css-extract-plugin
export var animationContainer = "_fq-0";
export var asteriskIcon = "_fq-8";
export var conversationLeftSection = "_fq-4";
export var conversationListItem = "_fq-3";
export var conversationMiddleSection = "_fq-5";
export var conversationRightSection = "_fq-6";
export var detailsContent = "_fq-1";
export var listContainer = "_fq-7";
export var modalContent = "_fq-2";